import _defaults from 'lodash/defaults'

export default {
  getters: {
    TripTeam: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].trip_team
          : {},
        {
          'section-heading': 'Trip Specialists',
          'section-subheading': '',
          team: []
        }
      )
    },
    Team: (state, getters) => {
      return getters.TripTeam.team
    }
  }
}
